export class EnumUtils {
  public static GetKeys(entity: object): string[] {
    return Object.keys(entity).filter((key: string) => {
      // note: assumes enum values are either strings or numbers
      const valueType = typeof entity[key];
      return valueType === 'number' || valueType === 'string';
    });
  }

  public static GetValues<T = any>(entity: object): T[] {
    return EnumUtils.GetKeys(entity).map((key: string) => {
      return entity[key];
    });
  }

  /**
   * To be used only for numeric enums with string keys.
   */
  public static GetNumericValues<T extends number>(entity: object): T[] {
    return Object.values(entity).filter((value: string | number) => typeof value === 'number');
  }
}
